<template>
  <three-step-approval
    api="home-delete-request"
    perm-prefix="approve_delete_home"
    :columns="columns"
    final-word="ລຶບ"
    :final-confirm="(n) => `ລຶບລູກຄ້າສາຍບ້ານ ${n} ລາຍ ພ້ອມບິນ ແລະ ບັນຊີ login? ລູກຄ້າທີ່ລຶບແລ້ວຈະເຫັນຢູ່ໜ້າປະຫວັດ.`"
  />
</template>

<script>
import ThreeStepApproval from '@/views/threeStep/ThreeStepApproval.vue';

export default {
  name: 'HomeDeleteApproval',
  components: { ThreeStepApproval },
  title() {
    return 'Vientiane Waste Co-Dev|Home Delete Approval';
  },
  data() {
    return {
      columns: [
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ບ້ານ', value: 'village', sortable: false },
        { text: 'ແພັກເກດ', value: 'package' },
      ],
    };
  },
};
</script>
